export default {
  unlocked_plural: 'Se han desbloqueado {{count}} ofertas',
  unlocked: 'La oferta {{offer}} se ha desbloqueado',
  removed_one: 'La oferta {{offer}} ha sido eliminada',
  removed_other: '{{count}} han sido eliminadas',
};
